import React from "react";

const LoadingAnimation: React.FC = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <img
      src="/gifs/logoLoadingAnimation.gif"
      alt="Loading..."
      style={{ width: 120, height: 100 }}
    />
  </div>
);

export default LoadingAnimation;
